import { useQueryParam } from '@occc-app/hooks/useQueryParam';
import { deletePaginationParams } from '@occc-app/hooks/usePaginationParams';
import { parseDate } from '@occc-app/lib/date';

export function useFilterParams<T extends string>(
  FilterType: { [key: string]: T },
  filterParam: string,
  beforeParam: string,
  afterParam: string,
) {
  // TODO Should be null and not string any
  return useQueryParam<T | 'any'>(
    (searchParams) => {
      const statusValue = searchParams.get(filterParam);
      if (statusValue) {
        const isCorrectStatus = Object.values(FilterType).includes(statusValue as T);

        if (isCorrectStatus) {
          return statusValue as T;
        }
      }

      return 'any';
    },
    (value, searchParams) => {
      if (value && value !== 'any') {
        searchParams.set(filterParam, value);
      } else {
        searchParams.delete(filterParam);
      }

      deletePaginationParams(searchParams, beforeParam, afterParam);
    },
  );
}

export function useFilterDateParams(filterParam: string, beforeParam: string, afterParam: string) {
  return useQueryParam<Date | null>(
    (searchParams) => {
      const dateValue = searchParams.get(filterParam);
      if (dateValue) {
        return parseDate(dateValue);
      }

      return null;
    },
    (value, searchParams) => {
      if (value) {
        searchParams.set(filterParam, value.toISOString());
      } else {
        searchParams.delete(filterParam);
      }

      deletePaginationParams(searchParams, beforeParam, afterParam);
    },
  );
}

export const isObjectRecord = (data: unknown): data is Record<string, unknown> => {
  return typeof data === 'object' && data !== null && !Array.isArray(data);
};

export const checkCustomDataForConfigOverrides = (
  data: unknown,
): data is { configOverrides: object } => {
  return (
    isObjectRecord(data) &&
    'configOverrides' in data &&
    typeof data.configOverrides === 'object' &&
    data.configOverrides !== null
  );
};
